// External imports
import * as actions from '../../actions/client/clientActions'

export const initialState = {
    clients: [],
    loading: false,
    hasErrors: false,
}

export default function clientsReducer(state = initialState, action) {
    switch (action.type) {
        case actions.GET_CLIENTS:
            return { ...state, loading: true }
        case actions.GET_CLIENTS_SUCCESS:
            return { clients: action.payload, loading: false, hasErrors: false }
        case actions.GET_CLIENTS_FAILURE:
            return { ...state, loading: false, hasErrors: true }

        // Add fn
        case actions.ADD_CLIENT:
            return {
                ...state,
                clients: [...state.clients, action.payload],
                loading: false, hasErrors: false
            }
        case actions.ADD_CLIENT_FAILURE:
            return { ...state, loading: false, hasErrors: true }

        // Update fn
        case actions.EDIT_CLIENT:
            return {
                ...state,
                clients: state.clients.map(
                    (client) => client.Id === action.payload.Id ? {
                        ...client,
                        ClientName: action.payload.ClientName,
                        ClientDescription: action.payload.ClientDescription,
                        InActiveFlag: action.payload.InActiveFlag
                    } : client),
                loading: false, hasErrors: false
            }
            case actions.EDIT_CLIENT_FAILURE:
                return { ...state, loading: false, hasErrors: true }
        default:
            return state
    }
}